import { Button } from "@/components/ui/button";
import { apiFetchBlob } from "@/lib/api";
import { openBlobInNewTab } from "@/lib/blob-url";
import { getQuotePdfUrl } from "@/lib/quotes";
import { toast } from "@/hooks/use-toast";
import { Printer } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";

export function QuotePdfLink({ quoteId }: { quoteId: number }) {
  // The PDF endpoint requires a bearer JWT (quotes:read policy). A plain <a href>
  // can't attach the Authorization header, so fetch the bytes with auth and hand
  // the browser a blob: URL via the shared helper.
  async function open() {
    try {
      const blob = await apiFetchBlob(getQuotePdfUrl(quoteId));
      if (!openBlobInNewTab(blob)) {
        toast.error("Your browser blocked the PDF tab. Allow pop-ups for this site, then try again.");
      }
    } catch {
      toast.error("Failed to open PDF");
    }
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="rounded-full h-8 w-8 border-slate-300 text-slate-600 hover:bg-slate-100"
          type="button"
          onClick={() => void open()}
        >
          <Printer className="h-4 w-4" />
          <span className="sr-only">Download PDF</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>Print PDF</TooltipContent>
    </Tooltip>
  );
}
